/* Count calendar days until the 2026 exam in the student's local date. Hide after exam day. */
(function () {
  function update() {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    document.querySelectorAll('.atar-exam-date[data-exam-date]').forEach(function (node) {
      var p = node.getAttribute('data-exam-date').split('-').map(Number);
      if (p.length !== 3) return;
      var target = new Date(p[0], p[1] - 1, p[2]);
      var left = Math.round((Date.UTC(target.getFullYear(), target.getMonth(), target.getDate()) - Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())) / 86400000);
      if (left < 0) { node.hidden = true; return; }
      node.hidden = false;
      var label = node.querySelector('.atar-exam-date__label');
      if (label) {
        if (node.classList.contains('atar-exam-date--product')) label.textContent = left === 0 ? 'exam today' : left === 1 ? 'day until exam' : 'days until exam';
        else label.innerHTML = left === 0 ? 'exam<br>today' : left === 1 ? 'day to<br>exam' : 'days to<br>exam';
      }
      var el = node.querySelector('.atar-exam-date__count');
      if (el) el.textContent = String(left);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
})();
